module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-23.b9b7a039.png";